var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-icon',{staticStyle:{"font-size":"30px"},attrs:{"color":_vm.getTypeColorAndIcon().classColor}},[_vm._v(" "+_vm._s(_vm.getTypeColorAndIcon().icon)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }